import Vue from 'vue';
import Inputmask from 'inputmask';

Vue.directive('focus', {
  inserted(el) {
    el.focus();
  },
  update(el) {
    el.focus();
  },
});

Vue.directive('mask', {
  bind: function (el, binding) {
    Inputmask(binding.value).mask(el.getElementsByTagName('INPUT')[0]);
  },
});
